import apiCall from '../utils/api-call/apiCall';
import { createHeaders } from './constants';

const apiList = async () => {
  try {
    const params = {
      populate: 'apiCategory',
    };
    return await apiCall('api-details', 'GET', params);
  } catch (error) {
    throw error;
  }
};
const apiCategortList = async () => {
  try {
    return await apiCall('get-company-apis', 'GET', null,  createHeaders());
  } catch (error) {
    throw error;
  }
};

const dashboardCharts = async (id, dashboardDates) => {
  try {
    const params = {
      apiId: id,
      startDate: dashboardDates?.startDate,
      endDate: dashboardDates?.endDate,
    };
    return await apiCall('api-consumption-dashboard', 'GET', params, createHeaders());
  } catch (error) {
    throw error;
  }
};

const usageData = async () => {
  try {
    const params = {
      apiId: 1,
      startDate: '2024-03-15',
      endDate: '2024-03-20',
    };
    return await apiCall('api-uses-list', 'GET', params);
  } catch (error) {
    throw error;
  }
};

const viewLogs = async (params) => {
  const { filterDate, token, id } = params;
  try {
    const queryParams = {
      filterDate,
      apiId: id,
    };
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return await apiCall('api-logs', 'GET', queryParams, headers);
  } catch (error) {
    throw error;
  }
};

const usageLogs = async (params) => {
  const {
    apiId, token, startDate, endDate,
  } = params;
  try {
    const queryParams = {
      apiId,
      startDate,
      endDate,
    };
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return await apiCall('api-uses-list', 'GET', queryParams, headers);
  } catch (error) {
    throw error;
  }
};

const downloadLogs = async (id, dashboardDates) => {
  try {
    const params = {
      apiId: id,
      startDate: dashboardDates.startDate,
      endDate: dashboardDates.endDate,
    };
    const responseType = 'blob';
    return await apiCall('export-api-log', 'GET', params, createHeaders(), responseType);
  } catch (error) {
    throw error;
  }
};

const getLogBySequenceId = async (requestId) => {
  try {
    const url = `api-logs/${requestId}`;
    return await apiCall(url, 'GET', null, createHeaders());
  } catch (error) {
    throw error;
  }
};

const averageResponseTime = async (startDate, endDate) => {
  try {
    const params = {
      startDate,
      endDate,
    };
    return await apiCall('average-response-time', 'GET', params, createHeaders());
  } catch (error) {
    throw error;
  }
};

//Dashboard Summary API
const dashboardSummary = async (token) => {
  try {
    return await apiCall('dashboard', 'GET', null, createHeaders(token));
  } catch (error) {
    throw error;
  }
};

//Dashboard Credit API
const dashboardCredits = async (token) => {
  try {
    return await apiCall('dashboard-credits', 'GET', null, createHeaders(token));
  } catch (error) {
    throw error;
  }
};

//Platform Dashboard Summary API
const platformDashboardSummary = async (token, dashboardDates) => {
  try {
    const params = {
      startDate: dashboardDates.startDate,
      endDate: dashboardDates.endDate,
    };
    return await apiCall('v2/admin/statistics', 'GET', params, createHeaders(token));
  } catch (error) {
    throw error;
  }
};

const customerGrothData = async (token, dashboardDates) => {
  try {
    return await apiCall(
      'v2/admin/customer-growth',
      'GET',
      dashboardDates,
      createHeaders(token)
    );
  } catch (error) {
    throw error;
  }
};

//Platform Dashboard category API
const apiUsageData = async (token, dashboardDates) => {
  try {
    return await apiCall(
      'v2/admin/api-usage',
      'GET',
      dashboardDates,
      createHeaders(token)
    );
  } catch (error) {
    throw error;
  }
};

const creditConsumptionData = async (token) => {
  try {
    return await apiCall('v2/admin/credit-consumption', 'GET', null, createHeaders(token));
  } catch (error) {
    throw error;
  }
};

const platformHealthdata = async (token, dashboardDates) => {
  try {
    return await apiCall(
      'v2/admin/performance-health',
      'GET',
      dashboardDates,
      createHeaders(token)
    );
  } catch (error) {
    throw error;
  }
};

const apiCactegoryUsagedata = async (token, dashboardDates) => {
  try {
    return await apiCall(
      'v2/admin/api-category-usage',
      'GET',
      dashboardDates,
      createHeaders(token)
    );
  } catch (error) {
    throw error;
  }
};
const topCustomersdata = async (token, page, pageSize, status, search, dashboardDates) => {
  try {
    const params = {
      company: search,
      status, 
      page,
      pageSize,
      ...(dashboardDates && {
        startDate: dashboardDates.startDate,
        endDate: dashboardDates.endDate,
      }),
    };

    return await apiCall(
      'v2/admin/customers',
      'GET',
      params,
      createHeaders(token)
    );
  } catch (error) {
    throw error;
  }
};

const companyDashboardSummary = async (token, decodedCompanyName, dashboardDates) => {
  try {
    const params = {
      company: decodedCompanyName,
      startDate: dashboardDates.startDate,
      endDate: dashboardDates.endDate,
    };

    return await apiCall(
      'v2/admin/company-api-dashboard',
      'GET',
      params,
      createHeaders(token)
    );
  } catch (error) {
    throw error;
  }
};

const companyDashboardDailyUsageTrendData = async (token, decodedCompanyName, dashboardDates) => {
  try {
    const params = {
      company: decodedCompanyName,
      startDate: dashboardDates.startDate,
      endDate: dashboardDates.endDate,
    };
    return await apiCall('v2/admin/daily-usage-trend', 'GET', params, createHeaders(token));
  } catch (error) {
    throw error;
  }
};

const companyDashboardApiWiseUsageData = async (token, decodedCompanyName, dashboardDates) => {
  try {
    const params = {
      company: decodedCompanyName,
      startDate: dashboardDates.startDate,
      endDate: dashboardDates.endDate,
    };

    return await apiCall(
      'v2/admin/company-apiwise-usage',
      'GET',
      params,
      createHeaders(token)
    );
  } catch (error) {
    throw error;
  }
};

const companyDashboardRecentApiCallData = async (token, decodedCompanyName, dashboardDates, page, pageSize, apiName) => {
  try {
    const params = {
      company: decodedCompanyName,
      startDate: dashboardDates.startDate,
      endDate: dashboardDates.endDate,
      page,
      pageSize
    };
    if (apiName) params.apiName = apiName;

    return await apiCall(
      'admin/recent-api-calls',
      'GET',
      params,
      createHeaders(token)
    );
  } catch (error) {
    throw error;
  }
};

const analyticsApiLogs = async (token, companyName, startDate, endDate) => {
  try {
    const params = { company: companyName, startDate, endDate };
    return await apiCall('api-analytics-grouped', 'GET', params, createHeaders(token));
  } catch (error) {
    throw error;
  }
};

const apiAnalyticsGrouped = async (token, companyName, startDate, endDate, apiName, page, pageSize) => {
  try {
    const params = { company: companyName, startDate, endDate };
    if (apiName) params.apiName = apiName;
    if (page) params.page = page;
    if (pageSize) params.pageSize = pageSize;
    return await apiCall('api-analytics-grouped', 'GET', params, createHeaders(token));
  } catch (error) {
    throw error;
  }
};

const apiAnalyticsGroupedExport = async (token, companyName, startDate, endDate) => {
  try {
    const params = { company: companyName, startDate, endDate };
    return await apiCall('api-analytics-grouped/export', 'GET', params, createHeaders(token), 'blob');
  } catch (error) {
    throw error;
  }
};

//Dashboard Recent Activity
const dashboardRecentActiviy = async (token) => {
  try {
    return await apiCall('recent-activities', 'GET', null, createHeaders(token));
  } catch (error) {
    throw error;
  }
};

export {
  apiList, dashboardCharts, usageData, viewLogs, apiCategortList, downloadLogs, usageLogs, getLogBySequenceId, averageResponseTime, dashboardSummary, dashboardCredits, platformDashboardSummary, customerGrothData, apiUsageData, creditConsumptionData, platformHealthdata, apiCactegoryUsagedata, topCustomersdata, companyDashboardSummary, companyDashboardDailyUsageTrendData, companyDashboardApiWiseUsageData, companyDashboardRecentApiCallData, dashboardRecentActiviy, analyticsApiLogs, apiAnalyticsGrouped, apiAnalyticsGroupedExport
};
 